module.exports = __webpack_public_path__ + "img/12.0fcced53.png";